function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { useRef } from "react";
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import Modal from "react-bootstrap/Modal";
import "./TaskDetailsModal.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Loader from "./../Loader/Loader";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { GoCalendar } from "react-icons/go";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import moment from "moment-timezone";
import { FiCalendar, FiUpload, FiDownload, FiInfo } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { GET_PRE_SIGNED_URL, ADD_FILE_DETAILS_MUTATION, TASK_DETAILS_QUERY, GET_ATTACHMENT_DETAILS, DELETE_ATTACHMENT_MUTATION } from "./query.js";
import { toast } from "react-toastify";
var TASK_TIMELINE_LIMIT = 20;
var TASK_ACTIVITY_LIMIT = 20;
import { FilterContext } from "../index";
export var TaskDetailsModal = /*#__PURE__*/React.memo(function NewTaskModal(props) {
  var showTaskModal = props.showTaskModal,
    handleCloseTaskDetails = props.handleCloseTaskDetails,
    projectId = props.projectId,
    timezone = props.timezone,
    projectName = props.projectName,
    getTaskDetails = props.getTaskDetails,
    taskDetailsData = props.taskDetailsData,
    taskDetailsError = props.taskDetailsError,
    taskDetailsLoading = props.taskDetailsLoading,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    taskDetailsFetchMore = props.taskDetailsFetchMore,
    TASK_EMP_LIMIT = props.TASK_EMP_LIMIT,
    TASK_EMP_OFFSETS = props.TASK_EMP_OFFSETS,
    setTaskDetailsActiveTab = props.setTaskDetailsActiveTab,
    getTaskEmployeeTimeline = props.getTaskEmployeeTimeline,
    taskTimelineData = props.taskTimelineData,
    taskTimelineError = props.taskTimelineError,
    taskTimelineLoading = props.taskTimelineLoading,
    taskTimelineFetchMore = props.taskTimelineFetchMore,
    getTaskActivitySummary = props.getTaskActivitySummary,
    taskActivitySummaryData = props.taskActivitySummaryData,
    taskActivitySummaryError = props.taskActivitySummaryError,
    taskActivitySummaryLoading = props.taskActivitySummaryLoading,
    taskActivitySummaryFetchMore = props.taskActivitySummaryFetchMore,
    role = props.role,
    userId = props.userId,
    userUrl = props.userUrl;
  if (showTaskModal == null) {
    return null;
  }
  var taskId = showTaskModal.taskId,
    taskName = showTaskModal.taskName;
  var handleTabSelect = function handleTabSelect(key) {
    setTaskDetailsActiveTab(key);
    if (key === "task-details") {
      getTaskDetails({
        variables: {
          projectId: projectId,
          organisationId: organisationId,
          taskId: taskId ? taskId : null,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(endDate).format("x")),
          timeZone: timezone,
          limit: TASK_EMP_LIMIT,
          offset: 0,
          role: role,
          userUrl: userUrl
        },
        fetchPolicy: "network-only",
        skip: showTaskModal == null && !showTaskModal.taskId
      });
    } else if (key === "timeline") {
      getTaskEmployeeTimeline({
        variables: {
          projectId: projectId,
          organisationId: organisationId,
          taskId: taskId ? taskId : null,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(endDate).format("x")),
          timeZone: timezone,
          limit: TASK_TIMELINE_LIMIT,
          offset: 0,
          role: role,
          userId: userId
        },
        fetchPolicy: "network-only",
        skip: !taskId
      });
    } else if (key === "activity-history") {
      getTaskActivitySummary({
        variables: {
          projectId: projectId,
          organisationId: organisationId,
          taskId: taskId ? taskId : null,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(endDate).format("x")),
          timeZone: timezone,
          limit: TASK_ACTIVITY_LIMIT,
          offset: 0
        }
      });
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: showTaskModal,
    onHide: handleCloseTaskDetails,
    centered: true,
    size: "xl",
    className: "project-detail-task-detail-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-detail-task-detail-modal-headers-new",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-detail-task-detail-modal-title-new"
  }, taskName)), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-detail-task-detail-edit-modal-body-new"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-tab-new"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "task-details",
    className: "task-header-menu-whole-div-content-whole-filter-content-div-table-view-modal",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "task-details",
    title: "Task Details"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-edit-modal-body-container-new"
  }, taskDetailsLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskDetailsError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TaskSummaryCard, {
    taskDetailsData: taskDetailsData,
    role: role,
    taskId: taskId,
    projectId: projectId,
    organisationId: organisationId,
    startDate: startDate,
    endDate: endDate,
    timezone: timezone,
    userUrl: userUrl,
    TASK_EMP_LIMIT: TASK_EMP_LIMIT,
    userId: userId
  }), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-comment-hole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-comment-hole-div-header"
  }, "Comments (0)"), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-comment-hole-div-content"
  }, "Coming soon")))), role != "Member" ? /*#__PURE__*/React.createElement(TaskEmployeeDetails, {
    taskDetailsData: taskDetailsData,
    taskDetailsFetchMore: taskDetailsFetchMore,
    TASK_EMP_LIMIT: TASK_EMP_LIMIT,
    TASK_EMP_OFFSETS: TASK_EMP_OFFSETS,
    taskDetailsLoading: taskDetailsLoading
  }) : null)), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "timeline",
    title: "Work History"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-edit-modal-body-container-timeline"
  }, taskTimelineLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskTimelineError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(TaskTimeline, {
    taskTimelineData: taskTimelineData,
    taskTimelineLoading: taskTimelineLoading,
    taskTimelineFetchMore: taskTimelineFetchMore
  }))), role != "Member" ? /*#__PURE__*/React.createElement(Tab, {
    eventKey: "activity-history",
    title: "Activity History"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-edit-modal-body-container"
  }, taskActivitySummaryLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskActivitySummaryError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(ActivityHistory, {
    taskActivitySummaryData: taskActivitySummaryData,
    taskActivitySummaryLoading: taskActivitySummaryLoading,
    taskActivitySummaryFetchMore: taskActivitySummaryFetchMore
  }))) : null))));
});
var TaskSummaryCard = function TaskSummaryCard(props) {
  var _taskDetailsData$task, _taskDetailsData$task2, _taskDetailsData$task3, _taskDetailsData$task4, _taskDetailsData$task5, _taskDetailsData$task6, _taskDetailsData$task7, _taskDetailsData$task8, _taskDetailsData$task9, _taskDetailsData$task10, _taskDetailsData$task11, _taskDetailsData$task12, _taskDetailsData$task13, _taskDetailsData$task14, _taskDetailsData$task15, _taskDetailsData$task16, _taskDetailsData$task17, _taskDetailsData$task18, _taskDetailsData$task19, _taskDetailsData$task20, _taskDetailsData$task21, _taskDetailsData$task22, _taskDetailsData$task23, _taskDetailsData$task24, _taskDetailsData$task25, _taskDetailsData$task26, _taskDetailsData$task27, _taskDetailsData$task28, _taskDetailsData$task29, _taskDetailsData$task30, _taskDetailsData$task31, _taskDetailsData$task32, _taskDetailsData$task33, _taskDetailsData$task34, _attachmentData$getAt, _attachmentData$getAt2;
  var taskDetailsData = props.taskDetailsData,
    role = props.role,
    taskId = props.taskId,
    projectId = props.projectId,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    timezone = props.timezone,
    userUrl = props.userUrl,
    TASK_EMP_LIMIT = props.TASK_EMP_LIMIT,
    userId = props.userId;
  var isDueDateCrossed = moment(taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task = taskDetailsData.taskDetails) === null || _taskDetailsData$task === void 0 ? void 0 : (_taskDetailsData$task2 = _taskDetailsData$task.taskData) === null || _taskDetailsData$task2 === void 0 ? void 0 : _taskDetailsData$task2.dueDate) < moment();
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    file = _React$useState2[0],
    setFile = _React$useState2[1];
  var fileInputRef = useRef(null);
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    deletingAttachmentId = _React$useState4[0],
    setDeletingAttachmentId = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isUploading = _React$useState6[0],
    setIsUploading = _React$useState6[1];
  var _React$useContext = React.useContext(FilterContext),
    organisationBilling = _React$useContext.organisationBilling;
  var _useQuery = useQuery(GET_ATTACHMENT_DETAILS, {
      variables: {
        organisationId: organisationId,
        projectId: projectId,
        taskId: taskId
      },
      fetchPolicy: "network-only",
      skip: !organisationId
    }),
    attachmentData = _useQuery.data,
    attachmentError = _useQuery.error,
    attachmentLoading = _useQuery.loading,
    attachmentRefetch = _useQuery.refetch;

  //get pre signed url
  var _useLazyQuery = useLazyQuery(GET_PRE_SIGNED_URL, {
      fetchPolicy: "no-cache"
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getPresignedUrl = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    importData = _useLazyQuery2$.data;

  /**** Add url details Submit  *****/
  var _useMutation = useMutation(ADD_FILE_DETAILS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addPresignedUrlDetails = _useMutation2[0],
    addNewProjectDetailsLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(DELETE_ATTACHMENT_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    deleteAttachment = _useMutation4[0],
    deleteAttachmentLoading = _useMutation4[1].loading;

  //delete
  var handleDeleteProject = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(attachmentId, attachmentUrl) {
      var _response$data, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(deleteAttachmentLoading || deletingAttachmentId)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            setDeletingAttachmentId(attachmentId);
            _context.next = 6;
            return deleteAttachment({
              variables: {
                attachmentId: attachmentId,
                organisationId: organisationId,
                attachmentUrl: attachmentUrl
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_ATTACHMENT_DETAILS,
                variables: {
                  projectId: projectId,
                  organisationId: organisationId,
                  taskId: taskId
                }
              }]
            });
          case 6:
            response = _context.sent;
            if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.deleteAttachment)) {
              toast.error("Error, please try again");
            } else {
              toast.success("Attachment deleted successfully!");
            }
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            console.error("Delete failed:", _context.t0);
            toast.error("Something went wrong, please try again");
          case 14:
            _context.prev = 14;
            setDeletingAttachmentId(null);
            return _context.finish(14);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 10, 14, 17]]);
    }));
    return function handleDeleteProject(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  // Trigger file input when upload icon clicked
  var handleUpload = function handleUpload() {
    var _fileInputRef$current;
    // Trigger hidden input click
    (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
  };

  // Handle file selection
  var handleFileChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      var selectedFile, allowedTypes, type;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            selectedFile = event.target.files[0];
            if (selectedFile) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            //setIsUploading(true);
            // Restrict type & size
            allowedTypes = ["image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // .xlsx
            "application/vnd.ms-excel",
            // .xls
            "text/csv",
            // .csv
            "application/msword",
            // .doc
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
            ];
            if (allowedTypes.includes(selectedFile.type)) {
              _context2.next = 7;
              break;
            }
            toast.error("Only JPG, PNG, PDF, Excel, Word, or CSV files are allowed");
            return _context2.abrupt("return");
          case 7:
            if (!((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.isTrial) == true && selectedFile.size > 2 * 1024 * 1024)) {
              _context2.next = 12;
              break;
            }
            toast.error("File size must be less than or equal to 2MB");
            return _context2.abrupt("return");
          case 12:
            if (!((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" && selectedFile.size > 10 * 1024 * 1024)) {
              _context2.next = 15;
              break;
            }
            toast.error("File size must be less than or equal to 10MB");
            return _context2.abrupt("return");
          case 15:
            // Store file in state
            setFile(selectedFile);

            // Get presigned URL from GraphQL backend

            // Log file type
            // console.log("Selected file:", file.name, "| MIME type:", file.type);

            //const type = file.type || "text/csv"; // fallback for CSV files
            // Some browsers don’t detect MIME for csv/xlsx
            type = selectedFile.type || "application/octet-stream"; // ✅ Request pre-signed URL from backend
            getPresignedUrl({
              variables: {
                fileType: type
              }
            });
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleFileChange(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Upload to Cloudflare once pre-signed URL is ready
  var uploadToCloud = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _importData$getPresig, uploadURL, key, uploadResponse, CLOUDFLARE_BASE_URL, variables, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(!importData || !file)) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          _context3.prev = 2;
          setIsUploading(true);
          _importData$getPresig = importData === null || importData === void 0 ? void 0 : importData.getPresignedUrl, uploadURL = _importData$getPresig.uploadURL, key = _importData$getPresig.key; // Step 2: Upload file directly to Cloudflare R2 using fetch()
          _context3.next = 7;
          return fetch(uploadURL, {
            method: "PUT",
            headers: {
              "Content-Type": file.type
            },
            body: file
          });
        case 7:
          uploadResponse = _context3.sent;
          if (uploadResponse.ok) {
            _context3.next = 11;
            break;
          }
          toast.error("Upload failed!");
          return _context3.abrupt("return");
        case 11:
          //alert("File uploaded successfully!");
          // Step 2: Call GraphQL mutation to store uploaded file details in DB
          // try {
          CLOUDFLARE_BASE_URL = "https://project-files.getworkfolio.com";
          variables = {
            // optionally:
            // fileUrl: `${CLOUDFLARE_PUBLIC_BASE_URL}/${key}`,
            // uploadedBy: userContext?.userId
            taskId: taskId,
            projectId: projectId,
            organisationId: organisationId,
            attachmentName: file.name,
            attachmentUrl: "".concat(CLOUDFLARE_BASE_URL, "/").concat(key)
          };
          _context3.next = 15;
          return addPresignedUrlDetails({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: GET_ATTACHMENT_DETAILS,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                taskId: taskId
              }
            }]
          });
        case 15:
          response = _context3.sent;
          if (!(!response || !response.data || response.data.addPresignedUrlDetails == null)) {
            _context3.next = 20;
            break;
          }
          throw new Error("Error while saving file details");
        case 20:
          toast.success("File uploaded and saved successfully!");
        case 21:
          _context3.next = 27;
          break;
        case 23:
          _context3.prev = 23;
          _context3.t0 = _context3["catch"](2);
          console.error("❌ Error while saving file details:", _context3.t0);
          if (_context3.t0.message.includes("already exist")) {
            toast.error("File already exists!");
          } else {
            toast.error("Failed to save file details!");
          }
        case 27:
          _context3.prev = 27;
          setIsUploading(false);
          setFile(null);
          if (fileInputRef.current) fileInputRef.current.value = "";
          return _context3.finish(27);
        case 32:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 23, 27, 32]]);
  })), [importData, file, addPresignedUrlDetails, organisationId, projectId, taskId
  // isUploading
  ]);

  // Trigger upload automatically when data arrives
  React.useEffect(function () {
    if (importData !== null && importData !== void 0 && importData.getPresignedUrl && file && !isUploading) {
      uploadToCloud();
    }
  }, [importData, file]);

  // const fileInputRef = useRef(null);
  // const handleImport = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const maxSize = 10 * 1024 * 1024; // 10 MB
  //     const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];

  //     // ✅ Check file size
  //     if (file.size > maxSize) {
  //       alert("File size must be 10MB or less.");
  //       e.target.value = ""; // reset input
  //       return;
  //     }

  //     // ✅ Check file type
  //     if (!allowedTypes.includes(file.type)) {
  //       alert("Only JPG, JPEG, PNG, or PDF files are allowed.");
  //       e.target.value = ""; // reset input
  //       return;
  //     }

  //     console.log("Accepted file:", file.name, "Size:", file.size, "Type:", file.type);
  //     // ✅ Do your upload/processing here
  //   }
  // };

  // const handleFileChange = (e) => {
  //   const selected = e.target.files[0];
  //   if (selected && selected.size <= 10 * 1024 * 1024) { // 10MB max
  //     if (["application/pdf", "image/jpeg", "image/png"].includes(selected.type)) {
  //       setFile(selected);
  //     } else {
  //       alert("Only PDF, JPG, or PNG files allowed");
  //     }
  //   } else {
  //     alert("File size must be 10MB or less");
  //   }
  // };
  // const handleIconClick = () => {
  //   fileInputRef.current.click(); // triggers hidden input
  // };
  // const handleUpload = async () => {
  //   if (!file) return alert("Select a file first");

  //   const formData = new FormData();
  //   formData.append("file", file);

  //   const res = await axios.post("http://localhost:5000/upload", formData, {
  //     headers: { "Content-Type": "multipart/form-data" },
  //   });

  //   console.log("Uploaded URL:", res.data.fileUrl);
  // };

  return /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole-header"
  }, role == "Member" ? "Worked Hours" : "Worked Hours"), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole-content-hours"
  }, taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task3 = taskDetailsData.taskDetails) === null || _taskDetailsData$task3 === void 0 ? void 0 : (_taskDetailsData$task4 = _taskDetailsData$task3.taskSummary) === null || _taskDetailsData$task4 === void 0 ? void 0 : _taskDetailsData$task4.totalTimeOnTask)), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole-header"
  }, "Estimated Time"), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole-content"
  }, (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task5 = taskDetailsData.taskDetails) === null || _taskDetailsData$task5 === void 0 ? void 0 : (_taskDetailsData$task6 = _taskDetailsData$task5.taskData) === null || _taskDetailsData$task6 === void 0 ? void 0 : _taskDetailsData$task6.estimatedTime) == "Not Added" ? "Not set" : taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task7 = taskDetailsData.taskDetails) === null || _taskDetailsData$task7 === void 0 ? void 0 : (_taskDetailsData$task8 = _taskDetailsData$task7.taskData) === null || _taskDetailsData$task8 === void 0 ? void 0 : _taskDetailsData$task8.estimatedTime)), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole-header"
  }, "Priority"), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole-content"
  }, taskDetailsData !== null && taskDetailsData !== void 0 && (_taskDetailsData$task9 = taskDetailsData.taskDetails) !== null && _taskDetailsData$task9 !== void 0 && (_taskDetailsData$task10 = _taskDetailsData$task9.taskData) !== null && _taskDetailsData$task10 !== void 0 && _taskDetailsData$task10.priority ? "".concat((taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task11 = taskDetailsData.taskDetails) === null || _taskDetailsData$task11 === void 0 ? void 0 : (_taskDetailsData$task12 = _taskDetailsData$task11.taskData) === null || _taskDetailsData$task12 === void 0 ? void 0 : _taskDetailsData$task12.priority.charAt(0).toUpperCase()) + (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task13 = taskDetailsData.taskDetails) === null || _taskDetailsData$task13 === void 0 ? void 0 : (_taskDetailsData$task14 = _taskDetailsData$task13.taskData) === null || _taskDetailsData$task14 === void 0 ? void 0 : _taskDetailsData$task14.priority.slice(1))) : "-")), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole-header"
  }, "Status"), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-small-whole-content"
  }, (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task15 = taskDetailsData.taskDetails) === null || _taskDetailsData$task15 === void 0 ? void 0 : (_taskDetailsData$task16 = _taskDetailsData$task15.taskData) === null || _taskDetailsData$task16 === void 0 ? void 0 : (_taskDetailsData$task17 = _taskDetailsData$task16.taskStatus) === null || _taskDetailsData$task17 === void 0 ? void 0 : _taskDetailsData$task17.charAt(0).toUpperCase()) + (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task18 = taskDetailsData.taskDetails) === null || _taskDetailsData$task18 === void 0 ? void 0 : (_taskDetailsData$task19 = _taskDetailsData$task18.taskData) === null || _taskDetailsData$task19 === void 0 ? void 0 : _taskDetailsData$task19.taskStatus.slice(1))))), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1"
  }, /*#__PURE__*/React.createElement(FiCalendar, {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1-content-header"
  }, "Due Date"), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1-content-text"
  }, taskDetailsData !== null && taskDetailsData !== void 0 && (_taskDetailsData$task20 = taskDetailsData.taskDetails) !== null && _taskDetailsData$task20 !== void 0 && (_taskDetailsData$task21 = _taskDetailsData$task20.taskData) !== null && _taskDetailsData$task21 !== void 0 && _taskDetailsData$task21.dueDate ? isDueDateCrossed ? "".concat(moment.unix((taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task22 = taskDetailsData.taskDetails) === null || _taskDetailsData$task22 === void 0 ? void 0 : (_taskDetailsData$task23 = _taskDetailsData$task22.taskData) === null || _taskDetailsData$task23 === void 0 ? void 0 : _taskDetailsData$task23.dueDate) / 1000).format("DD MMM, YYYY"), " (On Due)") : moment.unix((taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task24 = taskDetailsData.taskDetails) === null || _taskDetailsData$task24 === void 0 ? void 0 : (_taskDetailsData$task25 = _taskDetailsData$task24.taskData) === null || _taskDetailsData$task25 === void 0 ? void 0 : _taskDetailsData$task25.dueDate) / 1000).format("DD MMM, YYYY") : "Not Selected"))), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1-content-profile"
  }, taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task26 = taskDetailsData.taskDetails) === null || _taskDetailsData$task26 === void 0 ? void 0 : (_taskDetailsData$task27 = _taskDetailsData$task26.taskData) === null || _taskDetailsData$task27 === void 0 ? void 0 : _taskDetailsData$task27.taskCreatedName.charAt(0)), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1-content-whole-profile"
  }, "Created By"), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-1-description-part-1-content-whole-profile-name"
  }, taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task28 = taskDetailsData.taskDetails) === null || _taskDetailsData$task28 === void 0 ? void 0 : (_taskDetailsData$task29 = _taskDetailsData$task28.taskData) === null || _taskDetailsData$task29 === void 0 ? void 0 : _taskDetailsData$task29.taskCreatedName))))), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-2-whole-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-2-header"
  }, "Task Description"), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-2-header-text"
  }, taskDetailsData !== null && taskDetailsData !== void 0 && (_taskDetailsData$task30 = taskDetailsData.taskDetails) !== null && _taskDetailsData$task30 !== void 0 && _taskDetailsData$task30.taskData && taskDetailsData !== null && taskDetailsData !== void 0 && (_taskDetailsData$task31 = taskDetailsData.taskDetails) !== null && _taskDetailsData$task31 !== void 0 && (_taskDetailsData$task32 = _taskDetailsData$task31.taskData) !== null && _taskDetailsData$task32 !== void 0 && _taskDetailsData$task32.description ? taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task33 = taskDetailsData.taskDetails) === null || _taskDetailsData$task33 === void 0 ? void 0 : (_taskDetailsData$task34 = _taskDetailsData$task33.taskData) === null || _taskDetailsData$task34 === void 0 ? void 0 : _taskDetailsData$task34.description : /*#__PURE__*/React.createElement("span", {
    className: "task-detail-modal-view-secttion-whole-div-header-2-header-text-span"
  }, "No task description found."))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" || organisationId == "b8a0b6a0-389b-11ed-9b14-ebb2f09d4883" ? /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-2-header-new"
  }, /*#__PURE__*/React.createElement("div", null, "Attachments (", attachmentData === null || attachmentData === void 0 ? void 0 : attachmentData.getAttachmentDetails.length, ")"), isUploading ? /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole-icon-download-loader-add"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement("div", {
    onClick: handleUpload,
    className: "task-detail-modal-view-secttion-whole-div-header-2-header-new-attachment"
  }, "Add File ", /*#__PURE__*/React.createElement(FiUpload, {
    className: "task-detail-modal-view-secttion-whole-div-header-2-header-new-attachment-icon"
  }), /*#__PURE__*/React.createElement("input", {
    type: "file",
    ref: fileInputRef,
    style: {
      display: "none"
    }
    //accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    ,
    accept: " image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document ",
    onChange: handleFileChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-content-2-content-new"
  }, attachmentData === null || attachmentData === void 0 ? void 0 : (_attachmentData$getAt = attachmentData.getAttachmentDetails) === null || _attachmentData$getAt === void 0 ? void 0 : _attachmentData$getAt.map(function (employeeData, key) {
    var fileUrl = employeeData === null || employeeData === void 0 ? void 0 : employeeData.attachmentUrl; // URL returned from Cloudflare or backend

    var fileName = (employeeData === null || employeeData === void 0 ? void 0 : employeeData.attachmentName) || "downloaded-file";
    var handleDownload = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var response, blob, downloadUrl, link;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return fetch(fileUrl, {
                mode: "cors"
              });
            case 3:
              response = _context4.sent;
              if (response.ok) {
                _context4.next = 6;
                break;
              }
              throw new Error("Failed to download file");
            case 6:
              _context4.next = 8;
              return response.blob();
            case 8:
              blob = _context4.sent;
              downloadUrl = window.URL.createObjectURL(blob); // Create a temporary link
              link = document.createElement("a");
              link.href = downloadUrl;
              link.download = fileName; // forces browser download
              document.body.appendChild(link);
              link.click();

              // Cleanup
              link.remove();
              window.URL.revokeObjectURL(downloadUrl);
              _context4.next = 23;
              break;
            case 19:
              _context4.prev = 19;
              _context4.t0 = _context4["catch"](0);
              console.error("Error downloading file:", _context4.t0);
              toast.error("Failed to download file. Please try again.");
            case 23:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 19]]);
      }));
      return function handleDownload() {
        return _ref4.apply(this, arguments);
      };
    }();
    return /*#__PURE__*/React.createElement("div", {
      className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, employeeData === null || employeeData === void 0 ? void 0 : employeeData.attachmentName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole-name"
    }, employeeData === null || employeeData === void 0 ? void 0 : employeeData.attachmentName)), /*#__PURE__*/React.createElement("div", {
      className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole-icons"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, "File added by: ", employeeData === null || employeeData === void 0 ? void 0 : employeeData.addedByName), /*#__PURE__*/React.createElement("div", null, "File added at: ", moment.unix((employeeData === null || employeeData === void 0 ? void 0 : employeeData.addedAt) / 1000).format("MMM DD, YYYY"))))
    }, /*#__PURE__*/React.createElement(FiInfo, {
      className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole-icon-info"
    })), /*#__PURE__*/React.createElement("div", {
      className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole-icon-download",
      onClick: handleDownload
    }, /*#__PURE__*/React.createElement(FiDownload, null)), userId == (employeeData === null || employeeData === void 0 ? void 0 : employeeData.addedBy) ? deletingAttachmentId === (employeeData === null || employeeData === void 0 ? void 0 : employeeData.attachmentId) ? /*#__PURE__*/React.createElement("div", {
      className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole-icon-download"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole-icon-download-loader"
    }, /*#__PURE__*/React.createElement(Loader, null))) : /*#__PURE__*/React.createElement("div", {
      className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole-icon-download",
      onClick: function onClick() {
        return handleDeleteProject(employeeData === null || employeeData === void 0 ? void 0 : employeeData.attachmentId, employeeData === null || employeeData === void 0 ? void 0 : employeeData.attachmentUrl);
      }
    }, /*#__PURE__*/React.createElement(RiDeleteBinLine, null)) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, "Please contact the person who added the file to delete it.")
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-list-whole-icon-download"
    }, /*#__PURE__*/React.createElement(RiDeleteBinLine, null)))));
  }), attachmentData !== null && attachmentData !== void 0 && (_attachmentData$getAt2 = attachmentData.getAttachmentDetails) !== null && _attachmentData$getAt2 !== void 0 && _attachmentData$getAt2.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-file-text"
  }, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "You have seen all the attachment")) : /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-file"
  }, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "Yet to add a file! ")))) : /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-2-header-new"
  }, /*#__PURE__*/React.createElement("div", null, "Attachments (", attachmentData === null || attachmentData === void 0 ? void 0 : attachmentData.getAttachmentDetails.length, ")"), /*#__PURE__*/React.createElement(OverlayTrigger, {
    rootClose: true,
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "project-tooltip-start"
    }, "Upgrade to a premium plan to add file.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-header-2-header-new-attachment"
  }, "Add File ", /*#__PURE__*/React.createElement(FiUpload, {
    className: "task-detail-modal-view-secttion-whole-div-header-2-header-new-attachment-icon"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-content-2-content-new"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-detail-modal-view-secttion-whole-div-content-2-content-new-upgrade"
  }, "Upgrade to a premium plan to access attachments.")))));
};
var TaskEmployeeDetails = function TaskEmployeeDetails(props) {
  var _taskDetailsData$task41, _taskDetailsData$task42, _taskDetailsData$task43, _taskDetailsData$task44, _taskDetailsData$task45, _taskDetailsData$task46, _taskDetailsData$task47, _taskDetailsData$task48;
  var taskDetailsData = props.taskDetailsData,
    taskDetailsFetchMore = props.taskDetailsFetchMore,
    TASK_EMP_LIMIT = props.TASK_EMP_LIMIT,
    taskDetailsLoading = props.taskDetailsLoading;
  var TASK_EMP_OFFSETS = props.TASK_EMP_OFFSETS;
  var _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isAllLoaded = _React$useState8[0],
    setIsAllLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadingMore = _React$useState10[0],
    setIsLoadingMore = _React$useState10[1];
  React.useEffect(function () {
    var _taskDetailsData$task35, _taskDetailsData$task36, _taskDetailsData$task37, _taskDetailsData$task38;
    setIsAllLoaded((taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task35 = taskDetailsData.taskDetails) === null || _taskDetailsData$task35 === void 0 ? void 0 : (_taskDetailsData$task36 = _taskDetailsData$task35.taskUserSummaryDetails) === null || _taskDetailsData$task36 === void 0 ? void 0 : _taskDetailsData$task36.length) != 0 && (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task37 = taskDetailsData.taskDetails) === null || _taskDetailsData$task37 === void 0 ? void 0 : (_taskDetailsData$task38 = _taskDetailsData$task37.taskUserSummaryDetails) === null || _taskDetailsData$task38 === void 0 ? void 0 : _taskDetailsData$task38.length) < TASK_EMP_LIMIT ? true : false);
  }, [taskDetailsData]);
  var handleLoadMore = function handleLoadMore() {
    var _taskDetailsData$task39, _taskDetailsData$task40;
    if (taskDetailsLoading) return;
    setIsLoadingMore(true);
    taskDetailsFetchMore({
      variables: {
        offset: (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task39 = taskDetailsData.taskDetails) === null || _taskDetailsData$task39 === void 0 ? void 0 : (_taskDetailsData$task40 = _taskDetailsData$task39.taskUserSummaryDetails) === null || _taskDetailsData$task40 === void 0 ? void 0 : _taskDetailsData$task40.length) + 1
      },
      updateQuery: function updateQuery(prev, _ref5) {
        var _fetchMoreResult$task, _fetchMoreResult$task2, _fetchMoreResult$task3, _fetchMoreResult$task4, _prev$taskDetails, _fetchMoreResult$task5;
        var fetchMoreResult = _ref5.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$task = fetchMoreResult.taskDetails) === null || _fetchMoreResult$task === void 0 ? void 0 : (_fetchMoreResult$task2 = _fetchMoreResult$task.taskUserSummaryDetails) === null || _fetchMoreResult$task2 === void 0 ? void 0 : _fetchMoreResult$task2.length) === 0 && ((_fetchMoreResult$task3 = fetchMoreResult.taskDetails) === null || _fetchMoreResult$task3 === void 0 ? void 0 : (_fetchMoreResult$task4 = _fetchMoreResult$task3.taskUserSummaryDetails) === null || _fetchMoreResult$task4 === void 0 ? void 0 : _fetchMoreResult$task4.length) < TASK_EMP_LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          taskDetails: _objectSpread(_objectSpread({}, prev.taskDetails), {}, {
            taskUserSummaryDetails: [].concat(_toConsumableArray((_prev$taskDetails = prev.taskDetails) === null || _prev$taskDetails === void 0 ? void 0 : _prev$taskDetails.taskUserSummaryDetails), _toConsumableArray((_fetchMoreResult$task5 = fetchMoreResult.taskDetails) === null || _fetchMoreResult$task5 === void 0 ? void 0 : _fetchMoreResult$task5.taskUserSummaryDetails))
          })
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-details-employee-list-card-new"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-details-employee-list-card-header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "task-details-employee-list-card-title"
  }, " ", "Worked Employees", " ", /*#__PURE__*/React.createElement("span", null, Number(taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task41 = taskDetailsData.taskDetails) === null || _taskDetailsData$task41 === void 0 ? void 0 : _taskDetailsData$task41.totalUserInTask) > 0 ? "(".concat(Number(taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task42 = taskDetailsData.taskDetails) === null || _taskDetailsData$task42 === void 0 ? void 0 : _taskDetailsData$task42.totalUserInTask), ")") : ""))), /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-details-employee-list-card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-details-employee-list-card-data"
  }, /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "project-details-task-details-employee-list-card-data-table"
  }, /*#__PURE__*/React.createElement("tbody", null, taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task43 = taskDetailsData.taskDetails) === null || _taskDetailsData$task43 === void 0 ? void 0 : (_taskDetailsData$task44 = _taskDetailsData$task43.taskUserSummaryDetails) === null || _taskDetailsData$task44 === void 0 ? void 0 : _taskDetailsData$task44.map(function (employeeData, key) {
    var _employeeData$display;
    return /*#__PURE__*/React.createElement(React.Fragment, null, key == 0 ? /*#__PURE__*/React.createElement("tr", {
      className: "project-details-task-details-employee-list-card-data-header"
    }, /*#__PURE__*/React.createElement("th", null, "Employee Name"), /*#__PURE__*/React.createElement("th", null, "Employee Email"), /*#__PURE__*/React.createElement("th", null, "Total Worked Hours")) : null, /*#__PURE__*/React.createElement("tr", {
      className: "project-details-task-details-employee-list-card-details",
      key: key
    }, /*#__PURE__*/React.createElement("td", {
      className: "project-details-task-details-employee-list-card-details-avatar"
    }, (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === null || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === "" ? /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-card-avatar"
    }, employeeData === null || employeeData === void 0 ? void 0 : (_employeeData$display = employeeData.displayName) === null || _employeeData$display === void 0 ? void 0 : _employeeData$display.charAt(0).toUpperCase()) : /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-detail-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "DeskTime",
      src: employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl,
      className: "project-details-task-detail-card-avatar-profile-img"
    })), /*#__PURE__*/React.createElement("p", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.displayName)), /*#__PURE__*/React.createElement("td", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.emailId), /*#__PURE__*/React.createElement("td", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.totalTime)));
  }), (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$task45 = taskDetailsData.taskDetails) === null || _taskDetailsData$task45 === void 0 ? void 0 : (_taskDetailsData$task46 = _taskDetailsData$task45.taskUserSummaryDetails) === null || _taskDetailsData$task46 === void 0 ? void 0 : _taskDetailsData$task46.length) === 0 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colspan: "3",
    className: "text-center employee-no-data"
  }, "No data found!!!")) : null)), taskDetailsData !== null && taskDetailsData !== void 0 && (_taskDetailsData$task47 = taskDetailsData.taskDetails) !== null && _taskDetailsData$task47 !== void 0 && (_taskDetailsData$task48 = _taskDetailsData$task47.taskUserSummaryDetails) !== null && _taskDetailsData$task48 !== void 0 && _taskDetailsData$task48.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the employee")) : null)));
};
var TaskTimeline = function TaskTimeline(props) {
  var _taskTimelineData$tas4, _taskTimelineData$tas6, _taskTimelineData$tas7;
  var taskTimelineData = props.taskTimelineData,
    taskTimelineLoading = props.taskTimelineLoading,
    taskTimelineFetchMore = props.taskTimelineFetchMore;
  var _React$useState11 = React.useState(true),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isAllLoadedTimeline = _React$useState12[0],
    setIsAllLoadedTimeline = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isLoadingMoreTimeline = _React$useState14[0],
    setIsLoadingMoreTimeline = _React$useState14[1];
  React.useEffect(function () {
    var _taskTimelineData$tas, _taskTimelineData$tas2;
    setIsAllLoadedTimeline((taskTimelineData === null || taskTimelineData === void 0 ? void 0 : (_taskTimelineData$tas = taskTimelineData.taskEmployeeTimeline) === null || _taskTimelineData$tas === void 0 ? void 0 : _taskTimelineData$tas.length) != 0 && (taskTimelineData === null || taskTimelineData === void 0 ? void 0 : (_taskTimelineData$tas2 = taskTimelineData.taskEmployeeTimeline) === null || _taskTimelineData$tas2 === void 0 ? void 0 : _taskTimelineData$tas2.length) < TASK_TIMELINE_LIMIT ? true : false);
  }, [taskTimelineData]);
  var handleLoadMore = function handleLoadMore() {
    var _taskTimelineData$tas3;
    if (taskTimelineLoading) return;
    setIsLoadingMoreTimeline(true);
    taskTimelineFetchMore({
      variables: {
        offset: (taskTimelineData === null || taskTimelineData === void 0 ? void 0 : (_taskTimelineData$tas3 = taskTimelineData.taskEmployeeTimeline) === null || _taskTimelineData$tas3 === void 0 ? void 0 : _taskTimelineData$tas3.length) + 1
      },
      updateQuery: function updateQuery(prev, _ref6) {
        var _fetchMoreResult$task6, _fetchMoreResult$task7;
        var fetchMoreResult = _ref6.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$task6 = fetchMoreResult.taskEmployeeTimeline) === null || _fetchMoreResult$task6 === void 0 ? void 0 : _fetchMoreResult$task6.length) === 0 && ((_fetchMoreResult$task7 = fetchMoreResult.taskEmployeeTimeline) === null || _fetchMoreResult$task7 === void 0 ? void 0 : _fetchMoreResult$task7.length) < TASK_TIMELINE_LIMIT && !isAllLoadedTimeline) {
          setIsAllLoadedTimeline(true);
        }
        setIsLoadingMoreTimeline(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          taskEmployeeTimeline: [].concat(_toConsumableArray(prev.taskEmployeeTimeline), _toConsumableArray(fetchMoreResult.taskEmployeeTimeline))
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-employee-list-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-employee-list-card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-employee-list-card-data"
  }, /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "project-details-task-timeline-employee-list-card-data-table"
  }, /*#__PURE__*/React.createElement("tbody", null, taskTimelineData === null || taskTimelineData === void 0 ? void 0 : (_taskTimelineData$tas4 = taskTimelineData.taskEmployeeTimeline) === null || _taskTimelineData$tas4 === void 0 ? void 0 : _taskTimelineData$tas4.map(function (employeeData, key) {
    var _taskTimelineData$tas5, _employeeData$employe;
    return /*#__PURE__*/React.createElement(React.Fragment, null, key == 0 || !isSameDay(Number(taskTimelineData === null || taskTimelineData === void 0 ? void 0 : (_taskTimelineData$tas5 = taskTimelineData.taskEmployeeTimeline[key - 1]) === null || _taskTimelineData$tas5 === void 0 ? void 0 : _taskTimelineData$tas5.createdAt), Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.createdAt)) ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: "3",
      className: "task-tracker-date-td"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-timeline-date-divider-label-div ".concat(key != 0 ? "task-tracker-date-header-tr" : "task-tracker-date-header-first-tr")
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-timeline-list-date-divider-label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "project-details-task-timeline-date-divider-label-icon"
    }, /*#__PURE__*/React.createElement(GoCalendar, null)), /*#__PURE__*/React.createElement("span", null, isToday(Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.createdAt)) ? "Today" : isYesterday(Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.createdAt)) ? "Yesterday" : format(Number(employeeData === null || employeeData === void 0 ? void 0 : employeeData.createdAt), "dd-LLL-yyyy")))))) : null, key == 0 ? /*#__PURE__*/React.createElement("tr", {
      className: "project-details-task-timeline-employee-list-card-data-header"
    }, /*#__PURE__*/React.createElement("th", null, "Employee Name"), /*#__PURE__*/React.createElement("th", null, "Duration"), /*#__PURE__*/React.createElement("th", null, "Worked Time")) : null, /*#__PURE__*/React.createElement("tr", {
      className: "project-details-task-timeline-employee-list-card-details project-details-task-timeline-employee-list-card-details-hide",
      key: key
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-timeline-employee-list-card-details-avatar"
    }, (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === null || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === "" ? /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-card-avatar"
    }, employeeData === null || employeeData === void 0 ? void 0 : (_employeeData$employe = employeeData.employeeName) === null || _employeeData$employe === void 0 ? void 0 : _employeeData$employe.charAt(0).toUpperCase()) : /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-timeline-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "DeskTime",
      src: employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl,
      className: "project-details-task-timeline-card-avatar-profile-img"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeName), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, employeeData === null || employeeData === void 0 ? void 0 : employeeData.taskDescription)
    }, /*#__PURE__*/React.createElement("p", {
      "class": "project-task-time-mapping-task-tracker-table-description-details-p "
    }, employeeData === null || employeeData === void 0 ? void 0 : employeeData.taskDescription))))), /*#__PURE__*/React.createElement("td", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.totalTime), /*#__PURE__*/React.createElement("td", null, " ", moment.unix(Number(employeeData.startTime) / 1000).format("hh:mm A"), " -", " ", employeeData.endTime === "0" || employeeData.endTime == null ? "Ongoing" : moment.unix(Number(employeeData.endTime) / 1000).format("hh:mm A"), " ")));
  }), (taskTimelineData === null || taskTimelineData === void 0 ? void 0 : (_taskTimelineData$tas6 = taskTimelineData.taskEmployeeTimeline) === null || _taskTimelineData$tas6 === void 0 ? void 0 : _taskTimelineData$tas6.length) === 0 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colspan: "3",
    className: "text-center employee-no-data"
  }, "No data found !!!")) : null)), taskTimelineData !== null && taskTimelineData !== void 0 && (_taskTimelineData$tas7 = taskTimelineData.taskEmployeeTimeline) !== null && _taskTimelineData$tas7 !== void 0 && _taskTimelineData$tas7.length ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-load-more-button"
  }, !isAllLoadedTimeline ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMoreTimeline ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-timeline-load-more-button"
  }, "You have seen all the timeline")) : null)));
};
var TimelineItem = function TimelineItem(props) {
  var _data$displayName;
  var data = props.data,
    key = props.key;
  return /*#__PURE__*/React.createElement("div", {
    className: "timeline-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-item-content"
  }, /*#__PURE__*/React.createElement("time", null, " ", moment.unix(data.createdAt / 1000).format("MMMM DD YYYY, hh:mm A")), /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-activity-history-event-text"
  }, (data === null || data === void 0 ? void 0 : data.profileUrl) === null || (data === null || data === void 0 ? void 0 : data.profileUrl) === "" ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-activity-history-card-avatar"
  }, data === null || data === void 0 ? void 0 : (_data$displayName = data.displayName) === null || _data$displayName === void 0 ? void 0 : _data$displayName.charAt(0).toUpperCase()) : /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-activity-history-card-avatar-profile"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "DeskTime",
    src: data === null || data === void 0 ? void 0 : data.profileUrl,
    className: "project-details-task-activity-history-card-avatar-profile-img"
  })), data.activityData), /*#__PURE__*/React.createElement("span", {
    className: "circle"
  })));
};
var ActivityHistory = function ActivityHistory(props) {
  var _taskActivitySummaryD4, _taskActivitySummaryD5;
  var taskActivitySummaryData = props.taskActivitySummaryData,
    taskActivitySummaryLoading = props.taskActivitySummaryLoading,
    taskActivitySummaryFetchMore = props.taskActivitySummaryFetchMore;
  var _React$useState15 = React.useState(true),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isAllLoadedActivity = _React$useState16[0],
    setIsAllLoadedActivity = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isLoadingMoreActivity = _React$useState18[0],
    setIsLoadingMoreActivity = _React$useState18[1];
  React.useEffect(function () {
    var _taskActivitySummaryD, _taskActivitySummaryD2;
    setIsAllLoadedActivity((taskActivitySummaryData === null || taskActivitySummaryData === void 0 ? void 0 : (_taskActivitySummaryD = taskActivitySummaryData.taskActivitySummary) === null || _taskActivitySummaryD === void 0 ? void 0 : _taskActivitySummaryD.length) != 0 && (taskActivitySummaryData === null || taskActivitySummaryData === void 0 ? void 0 : (_taskActivitySummaryD2 = taskActivitySummaryData.taskActivitySummary) === null || _taskActivitySummaryD2 === void 0 ? void 0 : _taskActivitySummaryD2.length) < TASK_ACTIVITY_LIMIT ? true : false);
  }, [taskActivitySummaryData]);
  var handleLoadMore = function handleLoadMore() {
    var _taskActivitySummaryD3;
    if (taskActivitySummaryLoading) return;
    setIsLoadingMoreActivity(true);
    taskActivitySummaryFetchMore({
      variables: {
        offset: (taskActivitySummaryData === null || taskActivitySummaryData === void 0 ? void 0 : (_taskActivitySummaryD3 = taskActivitySummaryData.taskActivitySummary) === null || _taskActivitySummaryD3 === void 0 ? void 0 : _taskActivitySummaryD3.length) + 1
      },
      updateQuery: function updateQuery(prev, _ref7) {
        var _fetchMoreResult$task8, _fetchMoreResult$task9;
        var fetchMoreResult = _ref7.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$task8 = fetchMoreResult.taskActivitySummary) === null || _fetchMoreResult$task8 === void 0 ? void 0 : _fetchMoreResult$task8.length) === 0 && ((_fetchMoreResult$task9 = fetchMoreResult.taskActivitySummary) === null || _fetchMoreResult$task9 === void 0 ? void 0 : _fetchMoreResult$task9.length) < TASK_ACTIVITY_LIMIT && !isAllLoadedActivity) {
          setIsAllLoadedActivity(true);
        }
        setIsLoadingMoreActivity(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          taskActivitySummary: [].concat(_toConsumableArray(prev.taskActivitySummary), _toConsumableArray(fetchMoreResult.taskActivitySummary))
        });
      }
    });
  };
  return (taskActivitySummaryData === null || taskActivitySummaryData === void 0 ? void 0 : taskActivitySummaryData.taskActivitySummary.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "timeline-container"
  }, taskActivitySummaryData === null || taskActivitySummaryData === void 0 ? void 0 : (_taskActivitySummaryD4 = taskActivitySummaryData.taskActivitySummary) === null || _taskActivitySummaryD4 === void 0 ? void 0 : _taskActivitySummaryD4.map(function (data, idx) {
    return /*#__PURE__*/React.createElement(TimelineItem, {
      data: data,
      key: idx
    });
  }), taskActivitySummaryData !== null && taskActivitySummaryData !== void 0 && (_taskActivitySummaryD5 = taskActivitySummaryData.taskActivitySummary) !== null && _taskActivitySummaryD5 !== void 0 && _taskActivitySummaryD5.length ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-load-more-button"
  }, !isAllLoadedActivity ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMoreActivity ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-timeline-load-more-button project-management-miled-color"
  }, "You have seen all the activity")) : null) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    colspan: "3",
    className: "text-center employee-no-data "
  }, "No data found !!!"));
};
export var ManualTaskDetailsModal = /*#__PURE__*/React.memo(function NewManualTaskModal(props) {
  var showManualTaskDetailsModal = props.showManualTaskDetailsModal,
    handleCloseManualTaskDetails = props.handleCloseManualTaskDetails;
  if (showManualTaskDetailsModal == null) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: showManualTaskDetailsModal,
    onHide: handleCloseManualTaskDetails,
    centered: true,
    size: "lg",
    className: "project-detail-manual-task-detail-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-detail-task-detail-modal-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-detail-task-detail-modal-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-modal-title-project-name"
  }, showManualTaskDetailsModal === null || showManualTaskDetailsModal === void 0 ? void 0 : showManualTaskDetailsModal.projectName), showManualTaskDetailsModal === null || showManualTaskDetailsModal === void 0 ? void 0 : showManualTaskDetailsModal.taskDescription)), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-manual-task-detail-edit-modal-body ".concat(showManualTaskDetailsModal !== null && showManualTaskDetailsModal !== void 0 && showManualTaskDetailsModal.reviewedAt ? "project-details-manual-task-detail-edit-modal-body-reviewed" : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-detail-edit-modal-body-container"
  }, /*#__PURE__*/React.createElement(ManualTaskCard, {
    showManualTaskDetailsModal: showManualTaskDetailsModal
  }))));
});
var ManualTaskCard = function ManualTaskCard(props) {
  var showManualTaskDetailsModal = props.showManualTaskDetailsModal;
  var totalHours = showManualTaskDetailsModal.totalHours,
    reviewStatus = showManualTaskDetailsModal.reviewStatus,
    createdAt = showManualTaskDetailsModal.createdAt,
    reviewedName = showManualTaskDetailsModal.reviewedName,
    taskDate = showManualTaskDetailsModal.taskDate,
    startTime = showManualTaskDetailsModal.startTime,
    endTime = showManualTaskDetailsModal.endTime,
    reviewedAt = showManualTaskDetailsModal.reviewedAt;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, "Worked Hours")
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card-title text-dark"
  }, "Worked Hours")), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, totalHours)), /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card-title text-dark"
  }, "Task Date"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, moment.unix(taskDate / 1000).format("DD MMM, YYYY"))), /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card-title text-dark"
  }, "Task Time"), /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, " ", "".concat(startTime, " - ").concat(endTime))
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark task-details-card-title-text"
  }, "".concat(startTime, " - ").concat(endTime)))), /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card-title text-dark"
  }, "Created At"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, moment.unix(createdAt / 1000).format("DD MMM, YYYY"))), reviewStatus ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card-title text-dark"
  }, "Review Status"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, reviewStatus)) : null, reviewedName ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual--details-card-title text-dark"
  }, "Reviewed By"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, reviewedName)) : null, reviewedAt ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-details-manual-task-details-card-title text-dark"
  }, "Reviewed At"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark"
  }, moment.unix(reviewedAt / 1000).format("DD MMM, YYYY"))) : null);
};

// export const TaskDetailsModal = React.memo(function NewTaskModal(props) {
//   const {
//     showTaskModal,
//     handleCloseTaskDetails,
//     projectId,
//     timezone,
//     projectName,
//     getTaskDetails,
//     taskDetailsData,
//     taskDetailsError,
//     taskDetailsLoading,
//     organisationId,
//     startDate,
//     endDate,
//     taskDetailsFetchMore,
//     TASK_EMP_LIMIT,
//     TASK_EMP_OFFSETS,
//     setTaskDetailsActiveTab,
//     getTaskEmployeeTimeline,
//     taskTimelineData,
//     taskTimelineError,
//     taskTimelineLoading,
//     taskTimelineFetchMore,
//     getTaskActivitySummary,
//     taskActivitySummaryData,
//     taskActivitySummaryError,
//     taskActivitySummaryLoading,
//     taskActivitySummaryFetchMore,
//     role,
//     userId,
//     userUrl,
//   } = props;

//   if (showTaskModal == null) {
//     return null;
//   }

//   const { taskId, taskName } = showTaskModal;

//   const handleTabSelect = (key) => {
//     setTaskDetailsActiveTab(key);
//     if (key === "task-details") {
//       getTaskDetails({
//         variables: {
//           projectId,
//           organisationId,
//           taskId: taskId ? taskId : null,
//           startDate: Number(moment(startDate).format("x")),
//           endDate: Number(moment(endDate).format("x")),
//           timeZone: timezone,
//           limit: TASK_EMP_LIMIT,
//           offset: 0,
//           role,
//           userUrl,
//         },

//         fetchPolicy: "network-only",
//         skip: showTaskModal == null && !showTaskModal.taskId,
//       });
//     } else if (key === "timeline") {
//       getTaskEmployeeTimeline({
//         variables: {
//           projectId,
//           organisationId,
//           taskId: taskId ? taskId : null,
//           startDate: Number(moment(startDate).format("x")),
//           endDate: Number(moment(endDate).format("x")),
//           timeZone: timezone,
//           limit: TASK_TIMELINE_LIMIT,
//           offset: 0,
//           role,
//           userId,
//         },

//         fetchPolicy: "network-only",
//         skip: !taskId,
//       });
//     } else if (key === "activity-history") {
//       getTaskActivitySummary({
//         variables: {
//           projectId,
//           organisationId,
//           taskId: taskId ? taskId : null,
//           startDate: Number(moment(startDate).format("x")),
//           endDate: Number(moment(endDate).format("x")),
//           timeZone: timezone,
//           limit: TASK_ACTIVITY_LIMIT,
//           offset: 0,
//         },
//       });
//     }
//   };

//   return (
//     <Modal
//       show={showTaskModal}
//       onHide={handleCloseTaskDetails}
//       centered
//       size="lg"
//       className="project-detail-task-detail-modal"
//     >
//       <Modal.Header className="project-detail-task-detail-modal-header" closeButton>
//         <Modal.Title className="project-detail-task-detail-modal-title">
//           <div className="project-detail-task-detail-modal-title-project-name">{projectName}</div>
//           {taskName}
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="project-detail-task-detail-edit-modal-body">
//         <div className="project-detail-task-detail-tab">
//           <Tabs
//             defaultActiveKey={"task-details"}
//             onSelect={(e) => {
//               handleTabSelect(e);
//             }}
//           >
//             <Tab eventKey="task-details" title="Task Details">
//               <div className="project-detail-task-detail-edit-modal-body-container">
//                 {taskDetailsLoading ? (
//                   <Loader />
//                 ) : taskDetailsError ? (
//                   <div className="common-err-refresh-text">Something went wrong, please refresh the page.</div>
//                 ) : (
//                   <>
//                     <TaskSummaryCard taskDetailsData={taskDetailsData} role={role} />
//                     {role != "Member" ? (
//                       <TaskEmployeeDetails
//                         taskDetailsData={taskDetailsData}
//                         taskDetailsFetchMore={taskDetailsFetchMore}
//                         TASK_EMP_LIMIT={TASK_EMP_LIMIT}
//                         TASK_EMP_OFFSETS={TASK_EMP_OFFSETS}
//                         taskDetailsLoading={taskDetailsLoading}
//                       />
//                     ) : null}
//                   </>
//                 )}
//               </div>
//             </Tab>
//             <Tab eventKey="timeline" title="Work History">
//               <div className="project-detail-task-detail-edit-modal-body-container-timeline">
//                 {taskTimelineLoading ? (
//                   <Loader />
//                 ) : taskTimelineError ? (
//                   <div className="common-err-refresh-text">Something went wrong, please refresh the page.</div>
//                 ) : (
//                   <TaskTimeline
//                     taskTimelineData={taskTimelineData}
//                     taskTimelineLoading={taskTimelineLoading}
//                     taskTimelineFetchMore={taskTimelineFetchMore}
//                   />
//                 )}
//               </div>
//             </Tab>

//             {role != "Member" ? (
//               <Tab eventKey="activity-history" title="Activity History">
//                 <div className="project-detail-task-detail-edit-modal-body-container">
//                   {taskActivitySummaryLoading ? (
//                     <Loader />
//                   ) : taskActivitySummaryError ? (
//                     <div className="common-err-refresh-text">Something went wrong, please refresh the page.</div>
//                   ) : (
//                     <ActivityHistory
//                       taskActivitySummaryData={taskActivitySummaryData}
//                       taskActivitySummaryLoading={taskActivitySummaryLoading}
//                       taskActivitySummaryFetchMore={taskActivitySummaryFetchMore}
//                     />
//                   )}
//                 </div>
//               </Tab>
//             ) : null}
//           </Tabs>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// });

// const TaskSummaryCard = (props) => {
//   const { taskDetailsData, role } = props;

//   const isDueDateCrossed = moment(taskDetailsData?.taskDetails?.taskData?.dueDate) < moment();

//   return (
//     <>
//       <div className="project-details-task-details-card project-details-task-details-card-description-card">
//         <div className="project-details-task-details-card-title text-dark">Task Description</div>
//         <h4 className="text mb-0 mt-1 font-weight-bold text-dark">
//           {taskDetailsData?.taskDetails?.taskData && taskDetailsData?.taskDetails?.taskData?.description
//             ? taskDetailsData?.taskDetails?.taskData?.description
//             : "-"}
//         </h4>
//       </div>

//       {/* <div className="card shadow-sm project-details-task-details-card-description-card">
//         <div className="card-body">
//           <h5 className="card-title font-weight-bold task-details-card-title">Task Description</h5>
//           <p className="card-text text-muted">
//             {" "}
//             {taskDetailsData?.taskDetails?.taskData && taskDetailsData?.taskDetails?.taskData?.description
//               ? taskDetailsData?.taskDetails?.taskData?.description
//               : "-"}
//           </p>
//         </div>
//       </div> */}

//       <div className="project-details-task-details-summary">
//         {/* <div className="project-details-task-details-card">
//         <OverlayTrigger overlay={<Tooltip id="tooltip-demo-site">Today Worked Hours</Tooltip>}>
//           <div className="project-details-task-details-card-title text-dark">Today Worked Hours</div>
//         </OverlayTrigger>

//         <h4 className="text mb-0 mt-1 font-weight-bold text-dark">
//           {taskDetailsData?.taskDetails?.taskSummary?.totalTimeOnFilterTask}
//         </h4>
//       </div> */}

//         <div className="project-details-task-details-card">
//           <div className="project-details-task-details-card-title text-dark">
//             {role == "Member" ? "My Worked Hours" : "Total Worked Hours"}
//           </div>
//           <h4 className="text mb-0 mt-1 font-weight-bold text-dark">
//             {taskDetailsData?.taskDetails?.taskSummary?.totalTimeOnTask}
//           </h4>
//         </div>

//         <div className="project-details-task-details-card">
//           <div className="project-details-task-details-card-title text-dark">Task Estimated Hours</div>
//           <h4
//             className={`text mb-0 mt-1 font-weight-bold text-dark task-details-card-title-text ${
//               taskDetailsData?.taskDetails?.taskData?.estimatedTime == "Not Added"
//                 ? "task-tracker-task-details-card-value-none"
//                 : ""
//             }`}
//           >
//             {taskDetailsData?.taskDetails?.taskData?.estimatedTime}
//           </h4>
//         </div>
//         <div className="project-details-task-details-card">
//           <div className="project-details-task-details-card-title text-dark">Task Due Date</div>
//           <h4
//             className={`text mb-0 mt-1 font-weight-bold text-dark ${
//               taskDetailsData?.taskDetails?.taskData?.dueDate
//                 ? isDueDateCrossed
//                   ? "task-tracker-task-details-card-value-due-crossed"
//                   : ""
//                 : "task-tracker-task-details-card-value-none"
//             }`}
//           >
//             {taskDetailsData?.taskDetails?.taskData?.dueDate
//               ? isDueDateCrossed
//                 ? `${moment
//                     .unix(taskDetailsData?.taskDetails?.taskData?.dueDate / 1000)
//                     .format("DD MMM, YYYY")} (On Due)`
//                 : moment.unix(taskDetailsData?.taskDetails?.taskData?.dueDate / 1000).format("DD MMM, YYYY")
//               : "Not Selected"}
//           </h4>
//         </div>
//         <div className="project-details-task-details-card">
//           <div className="project-details-task-details-card-title text-dark">Task Priority</div>
//           <h4 className="text mb-0 mt-1 font-weight-bold text-dark">
//             {taskDetailsData?.taskDetails?.taskData?.priority
//               ? `${
//                   taskDetailsData?.taskDetails?.taskData?.priority.charAt(0).toUpperCase() +
//                   taskDetailsData?.taskDetails?.taskData?.priority.slice(1)
//                 }`
//               : "-"}
//           </h4>
//         </div>
//         <div className="project-details-task-details-card">
//           <div className="project-details-task-details-card-title text-dark">Task Status</div>
//           <h4 className="text mb-0 mt-1 font-weight-bold text-dark">
//             {taskDetailsData?.taskDetails?.taskData?.taskStatus?.charAt(0).toUpperCase() +
//               taskDetailsData?.taskDetails?.taskData?.taskStatus.slice(1)}
//           </h4>
//         </div>
//         {taskDetailsData?.taskDetails?.taskData?.taskCreatedName ? (
//           <div className="project-details-task-details-card">
//             <div className="project-details-task-details-card-title text-dark">Task Created By</div>
//             <h4 className="text mb-0 mt-1 font-weight-bold text-dark">
//               {taskDetailsData?.taskDetails?.taskData?.taskCreatedName}
//             </h4>
//           </div>
//         ) : null}
//       </div>
//     </>
//   );
// };

// const TaskEmployeeDetails = (props) => {
//   const { taskDetailsData, taskDetailsFetchMore, TASK_EMP_LIMIT, taskDetailsLoading } = props;
//   let { TASK_EMP_OFFSETS } = props;

//   const [isAllLoaded, setIsAllLoaded] = React.useState(true);
//   const [isLoadingMore, setIsLoadingMore] = React.useState(false);

//   React.useEffect(() => {
//     setIsAllLoaded(
//       taskDetailsData?.taskDetails?.taskUserSummaryDetails?.length != 0 &&
//         taskDetailsData?.taskDetails?.taskUserSummaryDetails?.length < TASK_EMP_LIMIT
//         ? true
//         : false
//     );
//   }, [taskDetailsData]);

//   const handleLoadMore = () => {
//     if (taskDetailsLoading) return;

//     setIsLoadingMore(true);

//     taskDetailsFetchMore({
//       variables: {
//         offset: taskDetailsData?.taskDetails?.taskUserSummaryDetails?.length + 1,
//       },

//       updateQuery: (prev, { fetchMoreResult }) => {
//         if (!fetchMoreResult) return prev;

//         if (
//           fetchMoreResult?.taskDetails?.taskUserSummaryDetails?.length === 0 &&
//           fetchMoreResult.taskDetails?.taskUserSummaryDetails?.length < TASK_EMP_LIMIT &&
//           !isAllLoaded
//         ) {
//           setIsAllLoaded(true);
//         }
//         setIsLoadingMore(false);

//         return {
//           ...prev,
//           taskDetails: {
//             ...prev.taskDetails,
//             taskUserSummaryDetails: [
//               ...prev.taskDetails?.taskUserSummaryDetails,
//               ...fetchMoreResult.taskDetails?.taskUserSummaryDetails,
//             ],
//           },
//         };
//       },
//     });
//   };

//   return (
//     <div className="project-details-task-details-employee-list-card">
//       <div className="task-details-employee-list-card-header">
//         <span className="task-details-employee-list-card-title">
//           {" "}
//           Worked Employees{" "}
//           <span>
//             {Number(taskDetailsData?.taskDetails?.totalUserInTask) > 0
//               ? `(${Number(taskDetailsData?.taskDetails?.totalUserInTask)})`
//               : ""}
//           </span>
//         </span>
//       </div>
//       <div className="project-details-task-details-employee-list-card-body">
//         <div className="project-details-task-details-employee-list-card-data">
//           <Table responsive="sm" className="project-details-task-details-employee-list-card-data-table">
//             <tbody>
//               {taskDetailsData?.taskDetails?.taskUserSummaryDetails?.map((employeeData, key) => {
//                 return (
//                   <>
//                     {key == 0 ? (
//                       <tr className="project-details-task-details-employee-list-card-data-header">
//                         <th>Employee Name</th>
//                         <th>Employee Email</th>
//                         <th>Total Worked Hours</th>
//                       </tr>
//                     ) : null}
//                     <tr className="project-details-task-details-employee-list-card-details" key={key}>
//                       <td className="project-details-task-details-employee-list-card-details-avatar">
//                         {employeeData?.profileUrl === null || employeeData?.profileUrl === "" ? (
//                           <div className="project-details-task-card-avatar">
//                             {employeeData?.displayName?.charAt(0).toUpperCase()}
//                           </div>
//                         ) : (
//                           <div className="project-details-task-detail-card-avatar-profile">
//                             <img
//                               alt="DeskTime"
//                               src={employeeData?.profileUrl}
//                               className="project-details-task-detail-card-avatar-profile-img"
//                             />
//                           </div>
//                         )}

//                         <p>{employeeData?.displayName}</p>
//                       </td>
//                       <td>{employeeData?.emailId}</td>
//                       <td>{employeeData?.totalTime}</td>
//                     </tr>
//                   </>
//                 );
//               })}
//               {taskDetailsData?.taskDetails?.taskUserSummaryDetails?.length === 0 ? (
//                 <tr>
//                   <td colspan="3" className="text-center employee-no-data">
//                     No data found!!!
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </Table>
//           {taskDetailsData?.taskDetails?.taskUserSummaryDetails?.length ? (
//             <div className="task-tracker-load-more-button">
//               {!isAllLoaded ? (
//                 <>
//                   {isLoadingMore ? (
//                     <div className="task-tracker-load-more-button">
//                       <Loader />
//                     </div>
//                   ) : (
//                     <Button
//                       variant="outline-primary"
//                       onClick={() => {
//                         handleLoadMore();
//                       }}
//                     >
//                       Load more
//                     </Button>
//                   )}
//                 </>
//               ) : (
//                 <p className="screenshot-load-more-button">You have seen all the employee</p>
//               )}
//             </div>
//           ) : null}
//         </div>
//       </div>
//     </div>
//   );
// };

// const TaskTimeline = (props) => {
//   const { taskTimelineData, taskTimelineLoading, taskTimelineFetchMore } = props;
//   console.log({taskTimelineData})

//   const [isAllLoadedTimeline, setIsAllLoadedTimeline] = React.useState(true);
//   const [isLoadingMoreTimeline, setIsLoadingMoreTimeline] = React.useState(false);

//   React.useEffect(() => {
//     setIsAllLoadedTimeline(
//       taskTimelineData?.taskEmployeeTimeline?.length != 0 &&
//         taskTimelineData?.taskEmployeeTimeline?.length < TASK_TIMELINE_LIMIT
//         ? true
//         : false
//     );
//   }, [taskTimelineData]);

//   const handleLoadMore = () => {
//     if (taskTimelineLoading) return;

//     setIsLoadingMoreTimeline(true);

//     taskTimelineFetchMore({
//       variables: {
//         offset: taskTimelineData?.taskEmployeeTimeline?.length + 1,
//       },

//       updateQuery: (prev, { fetchMoreResult }) => {
//         if (!fetchMoreResult) return prev;

//         if (
//           fetchMoreResult?.taskEmployeeTimeline?.length === 0 &&
//           fetchMoreResult.taskEmployeeTimeline?.length < TASK_TIMELINE_LIMIT &&
//           !isAllLoadedTimeline
//         ) {
//           setIsAllLoadedTimeline(true);
//         }
//         setIsLoadingMoreTimeline(false);

//         return {
//           ...prev,
//           taskEmployeeTimeline: [...prev.taskEmployeeTimeline, ...fetchMoreResult.taskEmployeeTimeline],
//         };
//       },
//     });
//   };

//   return (
//     <div className="project-details-task-timeline-employee-list-card">
//       <div className="project-details-task-timeline-employee-list-card-body">
//         <div className="project-details-task-timeline-employee-list-card-data">
//           <Table responsive="sm" className="project-details-task-timeline-employee-list-card-data-table">
//             <tbody>
//               {taskTimelineData?.taskEmployeeTimeline?.map((employeeData, key) => {
//                 return (
//                   <>
//                     {key == 0 ||
//                     !isSameDay(
//                       Number(taskTimelineData?.taskEmployeeTimeline[key - 1]?.createdAt),
//                       Number(employeeData?.createdAt)
//                     ) ? (
//                       <tr>
//                         <td colSpan="3" className="task-tracker-date-td">
//                           <div
//                             className={`project-details-task-timeline-date-divider-label-div ${
//                               key != 0 ? "task-tracker-date-header-tr" : "task-tracker-date-header-first-tr"
//                             }`}
//                           >
//                             <div className="project-details-task-timeline-list-date-divider-label">
//                               <span className="project-details-task-timeline-date-divider-label-icon">
//                                 <GoCalendar />
//                               </span>
//                               <span>
//                                 {isToday(Number(employeeData?.createdAt))
//                                   ? "Today"
//                                   : isYesterday(Number(employeeData?.createdAt))
//                                   ? "Yesterday"
//                                   : format(Number(employeeData?.createdAt), "dd-LLL-yyyy")}
//                               </span>
//                             </div>
//                           </div>
//                         </td>
//                       </tr>
//                     ) : null}

//                     {key == 0 ? (
//                       <tr className="project-details-task-timeline-employee-list-card-data-header">
//                         <th>Employee Name</th>
//                         {/* <th>Employee Email</th> */}
//                         <th>Duration</th>
//                         <th>Worked Time</th>
//                       </tr>
//                     ) : null}
//                     <tr
//                       className="project-details-task-timeline-employee-list-card-details project-details-task-timeline-employee-list-card-details-hide"
//                       key={key}
//                     >
//                       <td >
//                         <div className="project-details-task-timeline-employee-list-card-details-avatar">
//                           {employeeData?.profileUrl === null || employeeData?.profileUrl === "" ? (
//                             <div className="project-details-task-card-avatar">
//                               {employeeData?.employeeName?.charAt(0).toUpperCase()}
//                             </div>
//                           ) : (
//                             <div className="project-details-task-timeline-card-avatar-profile">
//                               <img
//                                 alt="DeskTime"
//                                 src={employeeData?.profileUrl}
//                                 className="project-details-task-timeline-card-avatar-profile-img"
//                               />
//                             </div>
//                           )}
//                           <div>
//                           <p>{employeeData?.employeeName}</p>
//                             <OverlayTrigger
//                                 rootClose
//                                 placement="bottom"
//                                 overlay={
//                                   <Tooltip id={`tooltip-bottom`} className="project-tooltip-start">
//                                     {employeeData?.taskDescription}
//                                   </Tooltip>
//                                 }
//                               >
//                                 <p class="project-task-time-mapping-task-tracker-table-description-details-p ">
//                                   {employeeData?.taskDescription}
//                                 </p>
//                               </OverlayTrigger>

//                           </div>
//                         </div>

//                       </td>
//                       {/* <td>{employeeData?.email}</td> moment(employeeData.startTime/1000)*/}
//                       <td>{employeeData?.totalTime}</td>
//                       <td>
//                         {" "}
//                         {moment.unix(Number(employeeData.startTime) / 1000).format("hh:mm A")} -{" "}
//                         {employeeData.endTime === "0" || employeeData.endTime == null
//                           ? "Ongoing"
//                           : moment.unix(Number(employeeData.endTime) / 1000).format("hh:mm A")}{" "}
//                       </td>
//                     </tr>
//                   </>
//                 );
//               })}
//               {taskTimelineData?.taskEmployeeTimeline?.length === 0 ? (
//                 <tr>
//                   <td colspan="3" className="text-center employee-no-data">
//                     No data found !!!
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </Table>
//           {taskTimelineData?.taskEmployeeTimeline?.length ? (
//             <div className="project-details-task-timeline-load-more-button">
//               {!isAllLoadedTimeline ? (
//                 <>
//                   {isLoadingMoreTimeline ? (
//                     <div className="project-details-task-timeline-load-more-button">
//                       <Loader />
//                     </div>
//                   ) : (
//                     <Button
//                       variant="outline-primary"
//                       onClick={() => {
//                         handleLoadMore();
//                       }}
//                     >
//                       Load more
//                     </Button>
//                   )}
//                 </>
//               ) : (
//                 <p className="project-details-task-timeline-load-more-button">You have seen all the timeline</p>
//               )}
//             </div>
//           ) : null}
//         </div>
//       </div>
//     </div>
//   );
// };

// const TimelineItem = (props) => {
//   const { data, key } = props;

//   return (
//     <div className="timeline-item">
//       <div className="timeline-item-content">
//         <time> {moment.unix(data.createdAt / 1000).format("MMMM DD YYYY, hh:mm A")}</time>
//         <p className="project-details-task-activity-history-event-text">
//           {data?.profileUrl === null || data?.profileUrl === "" ? (
//             <div className="project-details-task-activity-history-card-avatar">
//               {data?.displayName?.charAt(0).toUpperCase()}
//             </div>
//           ) : (
//             <div className="project-details-task-activity-history-card-avatar-profile">
//               <img
//                 alt="DeskTime"
//                 src={data?.profileUrl}
//                 className="project-details-task-activity-history-card-avatar-profile-img"
//               />
//             </div>
//           )}
//           {data.activityData}
//         </p>

//         <span className="circle" />
//       </div>
//     </div>
//   );
// };
// const ActivityHistory = (props) => {
//   const { taskActivitySummaryData, taskActivitySummaryLoading, taskActivitySummaryFetchMore } = props;

//   const [isAllLoadedActivity, setIsAllLoadedActivity] = React.useState(true);
//   const [isLoadingMoreActivity, setIsLoadingMoreActivity] = React.useState(false);

//   React.useEffect(() => {
//     setIsAllLoadedActivity(
//       taskActivitySummaryData?.taskActivitySummary?.length != 0 &&
//         taskActivitySummaryData?.taskActivitySummary?.length < TASK_ACTIVITY_LIMIT
//         ? true
//         : false
//     );
//   }, [taskActivitySummaryData]);

//   const handleLoadMore = () => {
//     if (taskActivitySummaryLoading) return;

//     setIsLoadingMoreActivity(true);

//     taskActivitySummaryFetchMore({
//       variables: {
//         offset: taskActivitySummaryData?.taskActivitySummary?.length + 1,
//       },

//       updateQuery: (prev, { fetchMoreResult }) => {
//         if (!fetchMoreResult) return prev;

//         if (
//           fetchMoreResult?.taskActivitySummary?.length === 0 &&
//           fetchMoreResult.taskActivitySummary?.length < TASK_ACTIVITY_LIMIT &&
//           !isAllLoadedActivity
//         ) {
//           setIsAllLoadedActivity(true);
//         }
//         setIsLoadingMoreActivity(false);

//         return {
//           ...prev,
//           taskActivitySummary: [...prev.taskActivitySummary, ...fetchMoreResult.taskActivitySummary],
//         };
//       },
//     });
//   };

//   return taskActivitySummaryData?.taskActivitySummary.length > 0 ? (
//     <div className="timeline-container">
//       {taskActivitySummaryData?.taskActivitySummary?.map((data, idx) => (
//         <TimelineItem data={data} key={idx} />
//       ))}

//       {taskActivitySummaryData?.taskActivitySummary?.length ? (
//         <div className="project-details-task-timeline-load-more-button">
//           {!isAllLoadedActivity ? (
//             <>
//               {isLoadingMoreActivity ? (
//                 <div className="project-details-task-timeline-load-more-button">
//                   <Loader />
//                 </div>
//               ) : (
//                 <Button
//                   variant="outline-primary"
//                   onClick={() => {
//                     handleLoadMore();
//                   }}
//                 >
//                   Load more
//                 </Button>
//               )}
//             </>
//           ) : (
//             <p className="project-details-task-timeline-load-more-button project-management-miled-color">
//               You have seen all the activity
//             </p>
//           )}
//         </div>
//       ) : null}
//     </div>
//   ) : (
//     <div>
//       <div colspan="3" className="text-center employee-no-data ">
//         No data found !!!
//       </div>
//     </div>
//   );
// };

// export const ManualTaskDetailsModal = React.memo(function NewManualTaskModal(props) {
//   const { showManualTaskDetailsModal, handleCloseManualTaskDetails } = props;

//   if (showManualTaskDetailsModal == null) {
//     return null;
//   }

//   return (
//     <Modal
//       show={showManualTaskDetailsModal}
//       onHide={handleCloseManualTaskDetails}
//       centered
//       size="lg"
//       className="project-detail-manual-task-detail-modal"
//     >
//       <Modal.Header className="project-detail-task-detail-modal-header" closeButton>
//         <Modal.Title className="project-detail-task-detail-modal-title">
//           <div className="project-detail-task-detail-modal-title-project-name">
//             {showManualTaskDetailsModal?.projectName}
//           </div>
//           {showManualTaskDetailsModal?.taskDescription}
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body
//         className={`project-details-manual-task-detail-edit-modal-body ${
//           showManualTaskDetailsModal?.reviewedAt ? "project-details-manual-task-detail-edit-modal-body-reviewed" : null
//         }`}
//       >
//         <div className="project-details-manual-task-detail-edit-modal-body-container">
//           <ManualTaskCard showManualTaskDetailsModal={showManualTaskDetailsModal} />
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// });

// const ManualTaskCard = (props) => {
//   const { showManualTaskDetailsModal } = props;
//   const { totalHours, reviewStatus, createdAt, reviewedName, taskDate, startTime, endTime, reviewedAt } =
//     showManualTaskDetailsModal;

//   return (
//     <div className="project-details-manual-task-details-summary">
//       <div className="project-details-manual-task-details-card">
//         <OverlayTrigger overlay={<Tooltip id="tooltip-demo-site">Worked Hours</Tooltip>}>
//           <div className="project-details-manual-task-details-card-title text-dark">Worked Hours</div>
//         </OverlayTrigger>

//         <h4 className="text mb-0 mt-1 font-weight-bold text-dark">{totalHours}</h4>
//       </div>
//       <div className="project-details-manual-task-details-card">
//         <div className="project-details-manual-task-details-card-title text-dark">Task Date</div>
//         <h4 className="text mb-0 mt-1 font-weight-bold text-dark">
//           {moment.unix(taskDate / 1000).format("DD MMM, YYYY")}
//         </h4>
//       </div>

//       <div className="project-details-manual-task-details-card">
//         <div className="project-details-manual-task-details-card-title text-dark">Task Time</div>
//         <OverlayTrigger overlay={<Tooltip id="tooltip-demo-site"> {`${startTime} - ${endTime}`}</Tooltip>}>
//           <h4 className="text mb-0 mt-1 font-weight-bold text-dark task-details-card-title-text">
//             {`${startTime} - ${endTime}`}
//           </h4>
//         </OverlayTrigger>
//       </div>
//       <div className="project-details-manual-task-details-card">
//         <div className="project-details-manual-task-details-card-title text-dark">Created At</div>
//         <h4 className="text mb-0 mt-1 font-weight-bold text-dark">
//           {moment.unix(createdAt / 1000).format("DD MMM, YYYY")}
//         </h4>
//       </div>
//       {reviewStatus ? (
//         <div className="project-details-manual-task-details-card">
//           <div className="project-details-manual-task-details-card-title text-dark">Review Status</div>
//           <h4 className="text mb-0 mt-1 font-weight-bold text-dark">{reviewStatus}</h4>
//         </div>
//       ) : null}
//       {reviewedName ? (
//         <div className="project-details-manual-task-details-card">
//           <div className="project-details-manual--details-card-title text-dark">Reviewed By</div>
//           <h4 className="text mb-0 mt-1 font-weight-bold text-dark">{reviewedName}</h4>
//         </div>
//       ) : null}
//       {reviewedAt ? (
//         <div className="project-details-manual-task-details-card">
//           <div className="project-details-manual-task-details-card-title text-dark">Reviewed At</div>
//           <h4 className="text mb-0 mt-1 font-weight-bold text-dark">
//             {moment.unix(reviewedAt / 1000).format("DD MMM, YYYY")}
//           </h4>
//         </div>
//       ) : null}
//     </div>
//   );
// };